import React from 'react';

import { flagStyles } from '../settings';

const SvgIT = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2592px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgIT;
